import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import ServicesMarquee from '../components/ServicesMarquee'
import ServicesNav from '../components/ServicesNav'
import ServiceGallery from '../components/ServiceGallery'
import { Link } from 'react-router';
const VisualBranding = () => {
  return (
    <>
    <Helmet>
      <title>Visual Branding & Logo Design - Om Softwares | Brand Identity Services</title>
      <meta name="description" content="Create a powerful brand identity with Om Softwares. From logo design to complete visual branding, we craft designs that resonate with your audience and elevate your business." />
      <meta property="og:title" content="Visual Branding & Logo Design - Om Softwares" />
      <meta property="og:description" content="Logo design, brand identity, and visual branding services that make your brand stand out." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/visual-branding" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Visual Branding & Logo Design - Om Softwares" />
      <meta name="twitter:description" content="Logo design, brand identity, and visual branding services that make your brand stand out." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <main>
    <Breadcrumb name="VISUAL BRANDING"/>
    <div className="service-details pt-125 ">
            <div className="container">
                <div className="row mt-none-30 align-items-center">
                    <div className="col-lg-6 mt-30">
                        <div className="section-title">
                            <span className="sub-title wow fadeInRight" data-wow-duration=".7s">Om Softwares - Design Studio</span>
                            <h3 className="title xb-split-text split-in-right mb-15">Creating Impactful Brand Identities <span>with Om Softwares</span></h3>

                        </div>
                        <div className="service-single-content">
                            <p className="mb-40 wow fadeInUp" data-wow-duration=".7s">Our mission is to create visually compelling brand identities that resonate with audiences. We are dedicated to delivering impactful visual branding solutions that elevate your business and make a lasting impression. Through creativity, collaboration, and attention to detail, we craft designs that truly represent your brand.</p>
                            <p className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration=".7s">
                                Our vision is to be a leader in visual branding, known for our innovative approach, commitment to quality, and the ability to build strong brand identities that stand out in today’s competitive market.
                            </p>

                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="service-details_image">
                            <img className="ukiyo" data-u-speed="1.2" src="assets/img/about/visual-branding-hero.webp" alt="Om Softwares Visual Branding and Logo Design Services"/>
                        </div>
                    </div>
                </div>
                <div className="row pt-80">
                    <div className="col-lg-8">
                        <div className="sv-details mt-30">
                            <h3 className="sv-title">Our mission is to create visually compelling brand identities <br/> that resonate with audiences and make a lasting impression!</h3>
                            <ul className="sv-list">
                                <li>Designing impactful brand logos</li>
                                <li>Crafting cohesive visual brand identities</li>
                                <li>Developing brand guidelines for consistent design application</li>
                                <li>Delivering high-quality assets in professional formats</li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 mt-30">
                        <div className="sd-details">
                            <h3 className="sd-title">LOGO DESIGN</h3>
                           <p className="sd-content pb-60">Our vision is to lead in logo design, delivering creative, memorable, and professional logos that enhance brand identity. We are committed to excellence, ensuring your logo stands out and drives recognition while fostering customer trust and satisfaction.</p>

                           <Link to="/contact" className="sd-button">Let’s Talk <img src="assets/img/icon/SD-01.svg" alt=""/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section className="service_details-slider z-3 pt-130">
                   
        <ServiceGallery img1="assets/img/searvice/sg_01.jpg" img2="assets/img/searvice/sg_02.jpg"
                        img3="assets/img/searvice/sg_03.jpg" img4="assets/img/searvice/sg_04.jpg"
                        img5="assets/img/searvice/sg_05.jpg" img6="assets/img/searvice/sg_01.jpg"/>
            <div className="container">
                <h3 className="sd-contents pt-125">Great user experience design lets users focus on the task they have to complete & <br/> evokes emotion without distracting them. Bonus points for when it also looks <br/> & feels aesthetically pleasing!</h3>
            </div>
        </section>
      <ServicesMarquee/>
      <ServicesNav prev="DIGITAL MARKETING" next="WEB DEVELOPMENT"/>

    </main>
    </>
  )
}

export default VisualBranding
